export enum ColorMode {
  Dark = 'dark',
  Light = 'light',
  System = 'system',
}

export const DEFAULT_STATE = {
  colorMode: ColorMode.System,
}
